var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-layout"},[_c('Navbar'),_vm._v(" "),_c('main',{staticClass:"public-content",attrs:{"id":"main-content"}},[_vm._t("default")],2),_vm._v(" "),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }